import { Outlet } from 'react-router-dom';
import Header from '../components/header';

const DefaultLayout = () => {
  return (
    <div className='flex flex-col w-full min-h-screen'>
      <Header />
      <div className='flex flex-1 w-full pt-16 overflow-hidden'>
        <main className='flex-1 min-h-[calc(100vh_-_64px)] bg-zinc-50 py-20'>
          <div className='container'>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default DefaultLayout;
